import React from "react";
import { useTranslation } from "react-i18next";
import { getCountryIcon } from "../../../../../utils/getCountryIcon";
import RouteChevronIcon from "../../../../shared/icons/RouteChevronIcon";
import RouteConnectorIcon from "../../../../shared/icons/RouteConnectorIcon";
import style from "./IntermediateRouteCard.module.scss";

const IntermediateRouteCard = ({ addresses, onViewRoute }) => {
  const { t } = useTranslation();
  const visibleAddresses = addresses.slice(0, 4);
  const remainingAddresses = addresses.slice(4);
  const connectorType = remainingAddresses.length ? 3 : addresses.length > 3 ? 2 : 1;

  return (
    <section className={style.card}>
      <div className={style.header}>
        <h3 className={style.title}>{t("orderInfoExpeditor.multiPointRoute.previewTitle")}</h3>
        <button type="button" className={style.link} onClick={onViewRoute}>
          {t("orderInfoExpeditor.multiPointRoute.viewRoute")}
          <RouteChevronIcon aria-hidden="true" />
        </button>
      </div>
      <div
        className={style.scroll}
        tabIndex={0}
        role="region"
        aria-label={t("orderInfoExpeditor.multiPointRoute.previewTitle")}
      >
        <ol className={`${style.points} ${remainingAddresses.length ? style.pointsCondensed : ""}`}>
          {visibleAddresses.map((address, index) => (
            <li className={style.item} key={address.id || index}>
              {index > 0 && (
                <RouteConnectorIcon
                  className={style.connector}
                  type={connectorType}
                  aria-hidden="true"
                />
              )}
              <div className={style.point}>
                <span className={style.operation}>
                  {address.type === "Loading"
                    ? t("orderInfoExpeditor.multiPointRoute.loading")
                    : address.type === "Unloading"
                      ? t("orderInfoExpeditor.multiPointRoute.unloading")
                      : "—"}
                </span>
                <span className={style.flag}>
                  <img
                    src={getCountryIcon(address.countryId)}
                    alt={address.countryName || ""}
                    width="20"
                    height="20"
                  />
                </span>
                <span className={style.city} title={address.cityName || address.countryName || undefined}>
                  {address.cityName || address.countryName || "—"}
                </span>
              </div>
            </li>
          ))}
          {remainingAddresses.length > 0 && (
            <li className={style.item}>
              <RouteConnectorIcon className={style.connector} type={connectorType} aria-hidden="true" />
              <div className={style.point}>
                <span className={style.operation}>
                  {t("orderInfoExpeditor.multiPointRoute.nextPoints")}
                </span>
                <div className={style.remaining}>
                  <div className={style.remainingFlags}>
                    {remainingAddresses.slice(0, 3).map((address, index) => (
                      <img
                        key={address.id || index}
                        src={getCountryIcon(address.countryId)}
                        alt={address.countryName || ""}
                        width="20"
                        height="20"
                      />
                    ))}
                  </div>
                  <span className={style.city}>+{remainingAddresses.length}</span>
                </div>
                <button type="button" className={`${style.link} ${style.more}`} onClick={onViewRoute}>
                  {t("orderInfoExpeditor.multiPointRoute.more")}
                </button>
              </div>
            </li>
          )}
        </ol>
      </div>
    </section>
  );
};

export default IntermediateRouteCard;
